module.exports = __webpack_public_path__ + "img/professionalRefurbishment@2x.b4ac3d3.webp";